<h5 mat-dialog-title>Employment Record: Pension</h5>

<mat-dialog-content>
    <form class="form-container" *ngIf="form" [formGroup]="form">
        <mat-form-field appearance="fill">
            <mat-label>
                Plan Type
            </mat-label>

            <mat-select disableOptionCentering formControlName="planType">
                <mat-option *ngFor="let planTypeOption of planTypeOptions | async" [value]="planTypeOption.id">{{planTypeOption.text}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Fund Provider
            </mat-label>

            <mat-select disableOptionCentering formControlName="fundProvider">
                <mat-option *ngFor="let fundProviderOption of fundProviderOptions | async" [value]="fundProviderOption.id">{{fundProviderOption.text}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Employer Contribution Percentage
            </mat-label>

            <mat-select disableOptionCentering formControlName="employerContributionPercentage">
                <mat-option *ngFor="let employerContributionPercentageOption of employerContributionPercentageOptions | async" [value]="employerContributionPercentageOption.id">{{employerContributionPercentageOption.text}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Employer Contribution Dollar Amount
            </mat-label>

            <input matInput
                type="number"
                formControlName="employerContributionDollarAmount">
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Employee Contribution Percentage
            </mat-label>

            <input matInput
                type="number"
                formControlName="employeeContributionPercentage">
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Employee Contribution Dollar Amount
            </mat-label>

            <input matInput
                type="number"
                formControlName="employeeContributionDollarAmount">
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Employee Voluntary Percentage
            </mat-label>

            <input matInput
                type="number"
                formControlName="employeeVoluntaryPercentage">
        </mat-form-field>

        <mat-form-field  appearance="fill">
            <mat-label>
                Start Date
            </mat-label>
        
            <input matInput [matDatepicker]="startDatepicker" formControlName="startDate">
            <span fxLayout="row" matSuffix>
                <mat-datepicker-toggle  [for]="startDatepicker"></mat-datepicker-toggle>
            </span>
            <mat-datepicker #startDatepicker></mat-datepicker> 
            <mat-hint></mat-hint>
        </mat-form-field>

        <mat-form-field  appearance="fill">
            <mat-label>
                End Date
            </mat-label>
        
            <input matInput [matDatepicker]="endDatepicker" formControlName="endDate">
            <span fxLayout="row" matSuffix>
                <mat-datepicker-toggle  [for]="endDatepicker"></mat-datepicker-toggle>
            </span>
            <mat-datepicker #endDatepicker></mat-datepicker> 
            <mat-hint></mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill">
            <mat-label>
                Comments
            </mat-label>
        
            <input matInput type="text" formControlName="comments">
        </mat-form-field>
    </form>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">Close</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">Save</button> 
</mat-dialog-actions>